import { AuthClientInstance, getAuthClient } from "@trumpf/ux.utils";
import { getEnvConfig } from "../config/api";

const authClientServiceCalls: AuthClientInstance = getAuthClient();

/**
 * utility to execute a function as soon as the user is authenticated
 * @param fn callback to be executed as soon as the user is authenticated
 * @returns a function to unsubscribe
 */
export function whenAuthenticated(fn: () => void): () => void {
    const { useMockData } = getEnvConfig();
    if (authClientServiceCalls.getAccessToken() !== null || useMockData) {
        fn();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => {};
    }
    return authClientServiceCalls.subscribe(fn);
}
